import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import {connect,bindActionCreators} from 'react-redux';
import * as actions from '../../../actions';
import { Panel, Button, Modal, Breadcrumb,OverlayTrigger,Popover } from 'react-bootstrap';
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class WebAdAssist extends Component{
	constructor(props){
      super(props);
      		this.state={
      			ad_assist_modal:false,
				ad_asst_confirm_modal:false,      			
      			queries:[],
      			ad_assist_flag:false,
      			ad_assist_banner:'',
      		}
		this.getAdAssistModal=this.getAdAssistModal.bind(this);      
 		this.close=this.close.bind(this);
		this.submitAdAssistData=this.submitAdAssistData.bind(this); 		
  	}
  	componentDidMount(){	
	    this.getbanner();		  		
  	}
	getAdAssistModal()
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('adassist_status','1');
			browserHistory.push('/web/login');
		}
		else
		{
			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
			var data1={from:'mobile_web',id:uid,pid:'',token:localStorage.getItem('token'),source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'checkaskExpert',
				success:function(data)
				{
					if(data.status==='success' && data.proceed===1)
					{
						this.setState({
							ad_assist_modal:!this.state.ad_assist_modal,
							assist_data:data,
							queries:data.queries
						});
						localStorage.removeItem('adassist_status');
					}
					if(data.status==='success' && data.proceed===0)
					{
						this.setState({
							ad_asst_confirm_modal:true,
							ad_asst_confirm_message:data.msg,
						});
						localStorage.removeItem('adassist_status');
					}
				}.bind(this),
				error:function(err)
				{

				}
			})
		}
	}
	submitAdAssistData(event)
	{
		event.preventDefault();
		var error_flag=false;
		var q_id=$('#ad-sel-question').val();
		if(q_id == 1){
			$('#ad-sel-question').css("color", "red");
			$('#ad-sel-question option').css("color", "#666");
			error_flag=true;
		}else{
			$('#ad-sel-question').css("color", "#666");
			$('#ad-sel-question option').css("color", "#666");
			error_flag=false;			
		}
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		var ad_time=this.state.ad_asst_time ? this.state.ad_asst_time : '0';
		if(ad_time == '0'){
					console.log("dv;slfjlkfr");
			error_flag =true;
			this.setState({
				time_err_status:true,
				time_err_msg:'* Required',
			})						
		}
		console.log(error_flag);
		if(!error_flag)
		{
			var data1={from:'mobile_web',id:uid,token:localStorage.token,pid:'',time:ad_time,desc:'',source:source,campaign:campaign,url_id:url_id,selectedQue:q_id};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'askExpert',
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							ad_assist_modal:false,
							ad_asst_confirm_message:data.message,
							ad_asst_confirm_modal:true,
						});

					}
					else
					{
						this.setState({
							ad_assist_modal:false,
							// ad_asst_confirm_message:data.message,
						});
					}
				}.bind(this),
				error:function(err)
				{

				}
			})
		}		
	}				
	close()
	{
		this.setState({
			ad_assist_modal:false,
			ad_asst_confirm_modal:false,
		});
	}
	setAdTime(val)
	{
		this.setState({
			ad_asst_time:val,
			time_err_status:false,
			time_err_msg:'',
		})
	}
	getbanner(){
			var data1={from:'desktop_web'}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'adassistbanner',	
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							ad_assist_banner:data.ad_assist_banner,
							ad_assist_flag:data.ad_assist_flag
						})
					}
				}.bind(this),
				error:function(err)
				{

				}
			})					
	}		  	
	render(){
    return (
    	<div>
    		{this.state.ad_assist_flag ? 
		  	<section className="container" style={{padding:'0px'}}>    	
	          <div className="web_ad_assist" onClick={() => this.getAdAssistModal()}>
	            <img  src={baseAssets+"icons/"+this.state.ad_assist_banner}  alt=".." />
	          </div>
	    	</section>
	    	: ''}
			  	<Modal className="ad_asst_modalbox" show={this.state.ad_assist_modal} onHide={this.close} id="ad_assist_web">
			  		<Modal.Body>
						<section id="assets_cnt_block">
								<span onClick={this.close}><Icon
				                    name='close'
				                    font='SimpleLineIcons'
				                    color='#fff'
				                    size={16}
				                    style={{position:'absolute',right:'10px',top:'8px'}}
				                  />
				                </span>
							<img  src={require('./../../../assets/images/ad_assest_pop_icon.png')}  alt="" />					
							<p>Please submit the details, one of our experts will respond shortly.</p>
					      <div className="aqua-txt-block">
						      <select id="ad-sel-question">
						        {this.state.queries.map((option) => <option key={option.id} value={option.id}>{option.question}</option>)}
						      </select>
						  	  <h6>Best time to contact:  {this.state.time_err_status ? <span style={{color:'red',fontSize:'10px'}}>{this.state.time_err_msg}</span> : ''}</h6>
		  			<form onSubmit={this.submitAdAssistData}>
			  			<div className="ad_asst_time_blk">
			  				<span className={this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(1)}}>9am - 12pm</span>
			  				<span className={this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(2)}}>12pm - 3pm</span>
			  				<span className={this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(3)}}>3pm - 5pm</span>
			  			</div>
						<div className="ad_asst_submit_blk">
							{/*<button type="button" onClick={this.close}>CANCEL</button>*/}
							<button type="submit">SCHEDULE CALL</button>
						</div>
					</form>								  	            
					      </div>
						</section>
			  		</Modal.Body>
			  	</Modal>
		  	<Modal className="mob_reqbestprice_confm"  show={this.state.ad_asst_confirm_modal} onHide={this.close}  >
			<Modal.Body>
				{this.state.ad_asst_confirm_message}
				<a onClick={this.close} className="req_conf_ok_btn">OK</a>
	  		</Modal.Body>
	  	</Modal>	    		
    	</div>
    ) 
	}		
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/WebAdAssist.js
 **/